<mat-tab-group class="menu">
    <mat-tab label="Reports"><ng-template matTabContent><app-reports></app-reports></ng-template></mat-tab>
    <ng-container *ngIf="vars.isSysAdmin() || vars.isAdmin()">
        <mat-tab label="Users"><ng-template matTabContent><app-users></app-users></ng-template></mat-tab>
        <mat-tab label="Groups"><ng-template matTabContent><app-groups></app-groups></ng-template></mat-tab>
        <mat-tab label="Services"><ng-template matTabContent><app-services></app-services></ng-template></mat-tab>
    </ng-container>
</mat-tab-group>